<template>
    <form @submit.prevent="handleSubmit" class="w-100">
        <template v-if="!issueId">
            <b-form-group
                :invalid-feedback="form.errors.get('title')"
                :label="$t('Title')"
                label-for="title"
            >
                <b-form-input
                    id="title"
                    v-model="form.title"
                    :state="form.errors.has('title') ? false : null"
                    required
                />
            </b-form-group>

            <b-form-group
                    :invalid-feedback="form.errors.get('subject')"
                    :label="$t('Issue subject')"
                    label-for="subject"
            >
                <b-form-input
                        id="subject"
                        v-model="form.subject"
                        :state="form.errors.has('subject') ? false : null"
                        type="url"
                />
            </b-form-group>

            <b-form-group
                :invalid-feedback="form.errors.get('group_id')"
                :label="$t('User group')"
                label-for="group"
            >
                <resource-select
                    id="group"
                    v-model="group"
                    :state="form.errors.has('group_id') ? false : null"
                    resource="groups"
                    required
                    @input="form.group_id = $event ? $event.id : null"
                />
            </b-form-group>
        </template>

        <b-form-group
            :label="$t('Your message')"
            label-for="text"
        >
            <text-editor
                id="text"
                ref="text"
                v-model="form.text"
                :state="form.errors.has('text') ? false : null"
                required
            />
            <b-form-invalid-feedback :state="form.errors.has('text') ? false : null">
                {{ form.errors.get('text') }}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-button :disabled="form.busy" type="submit" variant="primary">
            <b-spinner v-if="form.busy" small />
            {{ $t('Submit') }}
        </b-button>
    </form>
</template>

<script>
    import Form from 'vform';
    import ResourceSelect from "@/components/selects/ResourceSelect";
    import TextEditor from "@/components/TextEditor";

    export default {
        name: "NewMessage",
        components: {TextEditor, ResourceSelect},
        props: {
            issueId: {
                type: Number,
                default: null
            },
            subject: {
                type: String,
                default() {
                    return window.location.toString()
                }
            }
        },
        data() {
            return {
                group: null,
                form: new Form({
                    subject: this.subject,
                    project_id: this.$route.params.projectId,
                    text: null
                })
            }
        },
        computed: {
            apiUrl() {
                if (this.issueId) {
                    return `/api/issues/${this.issueId}/messages`
                } else {
                    return `/api/issues`
                }
            }
        },
        methods: {
            handleSubmit() {
                this.form
                    .post(this.apiUrl)
                    .then(({data}) => {
                        this.$emit('input', data)
                        this.form = new Form({
                            subject: this.subject,
                            project_id: this.$route.params.projectId,
                            text: null
                        });
                        this.$refs.text.$el.focus();
                    })
                    .catch(e => {
                        if (!e.response) {
                            throw e;
                        }
                    })
            }
        }
    }
</script>
